import styled from 'styled-components'

import { mediaMax } from '../../../styles/media'
import Button from '../../../components/display/Button'

export const FilterPanel = styled.div`
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;

  overflow-y: auto;
  overflow-x: hidden;

  padding: 16px;
  padding-bottom: 88px;

  font-size: 16px;
  text-align: left;

  color: #333;
  background: white;

  z-index: 9999999;

  &.show {
    display: block;
  }
`

export const FilterWrapper = styled.div``

export const FilterLabel = styled.div`
  color: #999;
  font-size: 14px;
  margin-bottom: 16px;
`

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;

  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.1875;

  padding: 16px 0 32px 0;

  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};

  svg {
    float: right;
    width: 32px;
    height: 32px;
  }
`

export const Buttons = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  align-items: center;

  margin: 0 -8px;
  padding: 16px;

  border-top: 1px solid #d5d5d5;
  background: white;

  ${Button} {
    flex: 1;
    margin: 0 8px;
  }
`

export const CloseButton = styled.button`
  position: absolute;

  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  right: -8px;
  top: -8px;
  appearance: none;
  padding: 0;
  margin: 0;
  border: 0;
  background: none;

  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};

  svg {
    width: 14px;
    height: 14px;
  }
`

export const Item = styled.button<{ selected?: boolean }>`
  display: inline-block;

  appearance: none;
  outline: 0;
  background: none;

  margin-bottom: 10px;
  margin-right: 10px;
  padding: 10px 20px;

  color: #343434;
  font-size: 14px;

  border: 1px solid #d5d5d5;
  border-radius: 6px;

  &:first-child {
    margin-left: 0;

    ${mediaMax.md`
      margin-top: 24px;
    `}
  }
  &:last-child {
    margin-right: 0;
  }

  ${({ theme, selected }) =>
    selected &&
    `
    color: white;
    background-color: ${theme.brand.jungle};
    border-color: ${theme.brand.jungle};
  `}
`
